<span
  *ngIf="
    storeInfo &&
    (!category.subCategoriesActive ||
      (category.subCategoriesActive && !category.subCategories) ||
      (category.subCategories && category.subCategories.length === 0)) &&
    !category.sliderDesign &&
    !category.cardsDesign &&
    !category.marketCardsDesign
  "
>
  <div [class]="isUposTabletMode ? 'upos-tablet-products-grid' : ''">
    <div
      [class]="isUposTabletMode ? 'upos-tablet-product-item' : ''"
      *ngFor="
        let product of (storeInfo &&
        storeInfo.design_settings &&
        storeInfo.design_settings.showOnlySelectedCategoryProducts
          ? filteredScrollProducts
          : category.products
        )
          | filterAvailableProducts : storeInfo.showAllUnavailableProducts
          | filterOnlyDineInDeliveryPickupProducts : orderPickup : dineIn;
        trackBy: productsTrackFn
      "
    >
      <app-product-items-mobile
        *ngIf="product.activeTotal && category.activeTotal"
        [category_id]="category.category_id"
        [product_id]="product.product_id"
        [productImage]="product.image"
        [imageBrowser]="imageBrowser"
        [cartProductIds]="cartProductIds"
        [hyperCategories]="hyperCategories"
        [dineIn]="dineIn"
        [orderPickup]="orderPickup"
        [groupStoreData]="groupStoreData"
        [selectedDineInTable]="selectedDineInTable"
        [selectedPreorderDate]="selectedPreorderDate"
        [webp]="webp"
      >
      </app-product-items-mobile>
      <!-- <app-product-items-mobile
      *ngIf="product.activeTotal && category.activeTotal"
      inViewport
      [inViewportOptions]="{ partial: true, threshold: [0, 1] }"
      (inViewportAction)="onIntersection($event, product)"
      [category_id]="category.category_id"
      [product_id]="product.product_id"
      [productImage]="product.image"
      [categoryAvailableTotal]="category.availableTotal"
      [imageBrowser]="imageBrowser"
      [cartProductIds]="cartProductIds"
    >
    </app-product-items-mobile> -->
    </div>
  </div>
  <ion-row
    style="width: 100%"
    *ngIf="
      storeInfo &&
      storeInfo.design_settings &&
      storeInfo.design_settings.showOnlySelectedCategoryProducts &&
      category &&
      category.products &&
      filteredScrollProducts &&
      filteredScrollProducts.length !== category.products.length
    "
  >
    <ion-col class="ion-text-center">
      <ion-spinner name="bubbles"></ion-spinner>
    </ion-col>
  </ion-row>
</span>
